<template>
  <div id="app">
    <router-view/>
    <div class="fixed bottom-0 left-0 right-0 z-50 w-full px-5 py-2 text-sm text-center text-black" style="background: rgba(237, 137, 54, 0.6);">Environnement de test</div>
  </div>
</template>

<script>
export default {
  watch: {
      '$route' (to, from) {
        document.title = to.meta.title || 'MiCare'
      }
  }
}
</script>